export default __webpack_public_path__ + "static/media/one.c768ad5a.png";